<template>
    <div class="card light-back max-content-width w-100">
        <div class="card-body">
            <div class="small-box">
                <span v-if="!store.termsText">{{ $t("Laeb lehte") }}</span>
                <span v-else v-html="store.termsText"></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useMainStore } from '../includes/store';
const store = useMainStore();
</script>
